/* @flow */

import isArray from 'lodash/isArray';

export const loadScripts: Function = (url: any): Object => {
    if (isArray(url)) {
        let prom = [];

        url.forEach(item => {
            prom.push(loadScripts(item));
        });

        return Promise.all(prom);
    }

    return new Promise((resolve, reject) => {
        let r = false,
            parent = null,
            s;

        if (url.type === 'script') {
            parent = document.body;
            s = document.createElement('script');

            s.type = 'text/javascript';
            s.src = url.src;
            s.id = url.id;
            s.async = url.async !== undefined ? url.async : true;
        } else {
            parent = document.getElementsByTagName('head')[0];
            s = document.createElement('link');

            s.type = 'text/css';
            s.rel = 'stylesheet';
            s.href = url.href;
            s.id = url.id;
        }

        s.onload = s.onreadystatechange = function() {
            if (!r && (!this.readyState || this.readyState === 'complete')) {
                r = true;
                resolve(this);
            }
        };

        s.onerror = s.onabort = reject;
        if (parent) {
            parent.appendChild(s);
        }
    });
};



// WEBPACK FOOTER //
// ./src/utils/scripts.js